module.exports = __webpack_public_path__ + "media/images/soar/comments_logo-b7aa0de6c89c2f399c9032d72bdf1b18.png";